import api from '../apis/api'
import { tokenConfig, tokenConfigUpload } from '../config'

export const AddCustomerAPI = (body, state) => {
  return new Promise((res, rej) => {
    api.post(`/customer`, body, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const ListCustomersAPI = (query, state) => {
  return new Promise((res, rej) => {
    api.get(`/customer?${query}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const UpdateCustomerAPI = (id, body, state) => {
  return new Promise((res, rej) => {
    api.put(`/customer/${id}`, body, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const UploadCustomersAPI = (query, body, state) => {
  return new Promise((res, rej) => {
    api.put(`/customer/file?${query}`, body, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const DeleteCustomerAPI = (id, state) => {
  return new Promise((res, rej) => {
    api.delete(`/customer/${id}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const GetCustomerAPI = (id, query, state) => {
  return new Promise((res, rej) => {
    api.get(`/customer/${id}?${query}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const GetCustomerEmailsAPI = (id, query, state) => {
  return new Promise((res, rej) => {
    api.get(`/customer/emails/${id}?${query}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const AddTagToCustomerAPI = (id, body, state) => {
  return new Promise((res, rej) => {
    api.post(`/customer/${id}/tag`, body, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const AddTagAPI = (body, state) => {
  return new Promise((res, rej) => {
    api.post(`/tag`, body, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const RemoveTagFromCustomerAPI = (id, tagId, state) => {
  return new Promise((res, rej) => {
    api.delete(`/customer/${id}/tag/${tagId}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const AddCommentAPI = (body, state) => {
  return new Promise((res, rej) => {
    api.post(`/customer/comment`, body, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const RemoveCommentAPI = (id, state) => {
  return new Promise((res, rej) => {
    api.delete(`/customer/comment/${id}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const UpdateCustomerWithFileAPI = (id, body, state) => {
  return new Promise((res, rej) => {
    api.put(`/customer/${id}/file`, body, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const AddSpendingAPI = (body, state) => {
  return new Promise((res, rej) => {
    api.post(`/customer/spending`, body, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const GetAnalyticsAPI = (query, state) => {
  return new Promise((res, rej) => {
    api.get(`/customer/crm?${query}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const ListTagsAPI = (query, state) => {
  return new Promise((res, rej) => {
    api.get(`/tag?${query}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const ListEmailTemplatesAPI = (query, state) => {
  return new Promise((res, rej) => {
    api.get(`/email-template?${query}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const AddEmailTemplateAPI = (body, state) => {
  return new Promise((res, rej) => {
    api.post(`/email-template`, body, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const GetEmailTemplateAPI = (id, state) => {
  return new Promise((res, rej) => {
    api.get(`/email-template/${id}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const UpdateEmailTemplateAPI = (id, body, state) => {
  return new Promise((res, rej) => {
    api.put(`/email-template/${id}`, body, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const DeleteEmailTemplateAPI = (id, state) => {
  return new Promise((res, rej) => {
    api.delete(`/email-template/${id}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const ListTop5TagsAPI = (query, state) => {
  return new Promise((res, rej) => {
    api.get(`/tag/top5?${query}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const AddCustomerTaskAPI = (id, data, state) => {
  return new Promise((res, rej) => {
    api.post(`/projects/${id}/task`, data, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const AddMediaAPI = (query, data, state) => {
  return new Promise((res, rej) => {
    api.post(`/customer/media?${query}`, data, tokenConfigUpload(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const ListMediaAPI = (id, state) => {
  return new Promise((res, rej) => {
    api.get(`/customer/media?customer=${id}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}

export const RemoveMediaAPI = (id, state) => {
  return new Promise((res, rej) => {
    api.delete(`/customer/media/${id}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}